/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line

import { Popover, Button } from 'antd'

const styles = {
  'pop-box': css`
    .ant-btn+.ant-btn {
      margin-top: 8px;
    }
  `,
}

export default (props: any) => {
  return <Popover content={
    <div css={styles["pop-box"]}>
      {props.children}
    </div>
  } title={props.title}>
    <Button size="small" type="link">{props.text}</Button>
  </Popover>
}